function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M162.623,28.3l22.811-6.226-1.208-2.442a3.214,3.214,0,0,0-4.305-1.452L159.5,28.3Z",
  transform: "translate(-149.251 -17.84)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M344.573,86.46a3.211,3.211,0,0,0-.848.116l-5.359,1.465L322,92.507h26.673l-1-3.675A3.207,3.207,0,0,0,344.573,86.46Z",
  transform: "translate(-301.309 -82.051)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M50.711,215.56H3.219a3.217,3.217,0,0,0-3.1,2.371,3.326,3.326,0,0,0-.116.842v35.8a3.214,3.214,0,0,0,3.213,3.213H50.7a3.214,3.214,0,0,0,3.213-3.213v-8.964H34.853a5.465,5.465,0,0,1-5.462-5.462V233a5.454,5.454,0,0,1,5.455-5.455H53.918v-8.771A3.2,3.2,0,0,0,50.711,215.56Z",
  transform: "translate(0 -202.856)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M516.933,437.6a3.212,3.212,0,0,0-1.125-.668,3.279,3.279,0,0,0-1.041-.173H495.613a3.214,3.214,0,0,0-3.213,3.213v7.152a3.214,3.214,0,0,0,3.213,3.213h19.155a3.272,3.272,0,0,0,1.041-.174,3.114,3.114,0,0,0,1.125-.668,3.2,3.2,0,0,0,1.047-2.371v-7.152A3.2,3.2,0,0,0,516.933,437.6Zm-14.612,6.586a1.607,1.607,0,0,1-1.606,1.606h-1.067a1.607,1.607,0,0,1-1.606-1.606v-1.067a1.574,1.574,0,0,1,.617-1.26,1.623,1.623,0,0,1,.989-.347h1.067a1.607,1.607,0,0,1,1.606,1.606v1.067Z",
  transform: "translate(-460.76 -409.843)"
});

function SvgWalletIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57.22,
    height: 54.927,
    viewBox: "0 0 57.22 54.927",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/walletIcon.e0686f1a.svg";
export { ForwardRef as ReactComponent };